import { colors } from '../../colors';
var address = {
  arrowColor: colors.clearBlue,
  textColor: colors.darkNight,
  borderColor: colors.darkNight,
  backgroundColor: colors.white
};
export default address;